<script>
	import Question_likert from './Question_likert.svelte';
	import Question_freetext from './Question_freetext.svelte';
	import Question_multiple_choice from './Question_multiple_choice.svelte';
	import Question_percentage from './Question_percentage.svelte';

	export let questionset_id;
	export let question;
	export let user_language;
	export let responses;
</script>

{#if question['type'] === 'likert'}
	<Question_likert {questionset_id} {question} {user_language} bind:responses />
{:else if question['type'] === 'freetext'}
	<Question_freetext {questionset_id} {question} {user_language} bind:responses />
{:else if question['type'] === 'multiple_choice'}
	<Question_multiple_choice {questionset_id} {question} {user_language} bind:responses />
{:else if question['type'] === 'percentage'}    
	<Question_percentage {questionset_id} {question} {user_language} bind:responses />
{:else}
	(unknown question type)
{/if}